import React, { useState, useEffect } from 'react';
import { pageService } from '../services/api';

const ResultsAnalysis = () => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const response = await pageService.getAllDocuments();
        setDocuments(response.data.documents || []);
      } catch (error) {
        console.error('Error fetching documents:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchDocuments();
  }, []);

  if (loading) return <div>Loading...</div>;

  return (
    <div className="results-analysis">
      <h3>Results Analysis</h3>
      <ul>
        {documents.map(doc => (
          <li key={doc.id}>
            <a href={`http://localhost:5000/uploads/${doc.file_path}`} target="_blank" rel="noopener noreferrer">
              {doc.title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ResultsAnalysis;